import { useMatch, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { useGridPrefsStore } from "../store/gridPrefsStore";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "../components/ui/DropdownMenu";
import { useVolWorkstationLayoutActions } from "../modules/curves/workspace/useVolWorkstationLayoutActions";
import { VolPublicLayoutMenu } from "../modules/curves/workspace/VolPublicLayoutMenu";

function VolWorkstationLayoutSection({ curveId }: { curveId: string }) {
  const { exportLayout, importLayout, resetLayout } = useVolWorkstationLayoutActions(curveId);

  return (
    <div className="terminal-menu-section">
      <div className="terminal-menu-section__header">Vol workstation</div>
      <div className="terminal-menu-section__sub" title={curveId}>
        {curveId}
      </div>
      <DropdownMenuItem
        className="terminal-menu-section__item !flex !items-center !justify-between !px-3 !py-1.5"
        onSelect={exportLayout}
      >
        <span>Export layout</span>
        <span className="terminal-menu-section__item-hint">↓</span>
      </DropdownMenuItem>
      <DropdownMenuItem
        className="terminal-menu-section__item !flex !items-center !justify-between !px-3 !py-1.5"
        onSelect={() => void importLayout()}
      >
        <span>Import layout</span>
        <span className="terminal-menu-section__item-hint">↑</span>
      </DropdownMenuItem>
      <DropdownMenuItem
        className="terminal-menu-section__item !flex !items-center !justify-between !px-3 !py-1.5"
        onSelect={resetLayout}
      >
        <span>Reset to default</span>
        <span className="terminal-menu-section__item-hint">↺</span>
      </DropdownMenuItem>
      <VolPublicLayoutMenu curveId={curveId} />
    </div>
  );
}

export function MenuBarUserMenu() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { theme, setTheme } = useGridPrefsStore();
  const volMatch = useMatch("/curves/workstation/:curveId");
  const volCurveId = volMatch?.params.curveId?.trim() ?? "";

  return (
    <DropdownMenu align="right">
      <DropdownMenuTrigger className="max-w-[10rem] truncate">
        {user?.username ?? "User"} ▾
      </DropdownMenuTrigger>
      <DropdownMenuContent minWidth={220} className="text-right !rounded-none !py-0">
        <DropdownMenuLabel>{user?.username ?? "Signed in"}</DropdownMenuLabel>
        {volCurveId ? (
          <>
            <DropdownMenuSeparator />
            <VolWorkstationLayoutSection curveId={volCurveId} />
          </>
        ) : null}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => navigate("/account")}>Account settings</DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => setTheme(theme === "dark" ? "light" : "dark")}
        >
          {theme === "dark" ? "Light theme" : "Dark theme"}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => void logout()}>Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
